import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { EditionListService } from './edition.service';
import { Edition } from '../models/global/edition';

@Injectable()
export class EditionResolve implements Resolve<Edition> {

  constructor(private editionListService: EditionListService) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.editionListService.waitForEdition().first();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/editions/edition-resolve.ts